export const contentTableConfig = {
  title: '客户基础信息列表',
  propList: [
    { prop: 'custName', label: '客户昵称', minWidth: '100' },
    { prop: 'empName', label: '使用人', minWidth: '100' },
    { prop: 'deptName', label: '所属部门', minWidth: '100' },
    { prop: 'empUserId', label: '企微号', minWidth: '120' },
    { prop: 'corpName', label: '主体', minWidth: '120' },
    { prop: 'stockYearLimit', label: '炒股年限', minWidth: '100' },
    { prop: 'fundScale', label: '资金规模', minWidth: '100' },
    { prop: 'longShortLine', label: '长/短线', minWidth: '100' },
    { prop: 'operationStyle', label: '操作风格', minWidth: '100' }
  ],
  showIndexColumn: true,
  showSelectColumn: false
}
